<template>
  <div id="app">
    <router-view />

    <div class="global-safe-footer">
      <span class="lock-icon">♙</span>
      <span @click="msgPup = true"
        >Vos informations sont sécurisées,Cliquez ici pour en savoir plus</span
      >
    </div>

    <div class="transfer-mask" v-if="msgPup">
      <div class="transfer-result-card">
        <CGU></CGU>
      </div>
    </div>

    <!-- 全局通知弹窗：盖住整个屏幕 -->
    <div
      v-if="showNotifyModal"
      class="global-notify-mask"
      @click.self="closeNotifyModal"
    >
      <div class="global-notify-dialog" @click.stop>
        <div class="notify-tag">NOTIFICATIONS</div>

        <div class="notify-tag-title">Recevoir les notifications</div>

        <p>
          Autorisez les notifications pour recevoir les alertes importantes sur
          notre service.
        </p>

        <div class="notify-actions">
          <button class="btn-cancel" type="button" @click="closeNotifyModal">
            Non merci
          </button>

          <button
            class="btn-confirm"
            type="button"
            @click="requestNotificationPermission"
          >
            Autoriser
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CGU from '@/views/CGU.vue'
export default {
  name: 'App',

  data() {
    return {
      showNotifyModal: false,
      msgPup: false
    }
  },

  created() {
    this.$root.$on('openNotifyModal', this.openNotifyModal)
  },

  beforeDestroy() {
    this.$root.$off('openNotifyModal', this.openNotifyModal)
    document.body.classList.remove('notify-modal-open')
  },

  methods: {
    openNotifyModal() {
      this.showNotifyModal = true
      document.body.classList.add('notify-modal-open')
    },

    closeNotifyModal() {
      this.showNotifyModal = false
      document.body.classList.remove('notify-modal-open')
    },

    async requestNotificationPermission() {
      if (!('Notification' in window)) {
        this.closeNotifyModal()
        return
      }

      try {
        await Notification.requestPermission()
      } catch (err) {
        console.warn('Notification permission failed:', err)
      }

      this.closeNotifyModal()
    }
  },
  components: {
    CGU
  }
}
</script>

<style lang="less">
* {
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 0;
}

body {
  background: #f6f7fb;
  font-family: Inter, Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body.notify-modal-open {
  overflow: hidden;
}

button,
input,
select,
textarea {
  font-family: inherit;
}

button {
  cursor: pointer;
}

a {
  color: inherit;
  text-decoration: none;
}

#app {
  min-height: 100vh;
  padding-bottom: 48px;
}

.global-safe-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  height: 48px;
  border-top: 1px solid #d7d9e0;
  background: rgba(255, 255, 255, 0.96);
  color: #9aa0ad;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  backdrop-filter: blur(8px);
  cursor: pointer;
  .lock-icon {
    font-size: 14px;
    color: #9aa0ad;
  }
}
.transfer-mask {
  position: fixed;
  inset: 0;
  z-index: 19;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(3px);

  overflow: hidden;
  overscroll-behavior: none;
  z-index: 10;
}
.transfer-result-card {
  width: 850px;
  height: 700px;
  margin-top: 18px;
  padding: 0;
  border: 1px solid #e4e6ef;
  border-radius: 16px;
  background: #fff;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;

  overflow: hidden;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18),
    0 6px 18px rgba(24, 37, 137, 0.08);

  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
  img {
    max-width: 100%;
    max-height: 360px;
    display: block;
    margin: 0 auto;
    border-radius: 10px;
  }
}
/* 移动端适配 */
@media (max-width: 768px) {
  .transfer-result-card {
    width: calc(100vw - 50px);
    height: calc(100vh - 150px);
    margin-top: 0;
    border-radius: 14px;
  }
}

/* 小屏手机 */
@media (max-width: 375px) {
  .transfer-result-card {
    width: calc(100vw - 50px);
    height: calc(100vh - 150px);
    border-radius: 12px;
  }
}
/* 全屏蒙版，盖住所有页面内容和底部栏 */
.global-notify-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
  background: rgba(9, 16, 46, 0.66);
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-notify-dialog {
  width: 400px;
  min-height: 188px;
  background: #fff;
  border-radius: 16px;
  padding: 22px 22px 18px;
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.28);
  color: #1d2433;
  .notify-tag-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .notify-tag {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 10px;
    border-radius: 999px;
    background: #fff1df;
    color: #c7501d;
    font-size: 9px;
    letter-spacing: 0.5px;
    margin-bottom: 10px;
  }

  h2 {
    margin: 0 0 9px;
    color: #202638;
    font-size: 21px;
    line-height: 1.15;
    font-weight: 900;
    letter-spacing: -0.3px;
  }

  p {
    margin: 0;
    color: #6f7583;
    font-size: 12px;
    line-height: 1.45;
    font-weight: 500;
  }

  .notify-actions {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .btn-cancel,
  .btn-confirm {
    height: 34px;
    border: 0;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 900;
  }

  .btn-cancel {
    background: #eef1f5;
    color: #4b5260;
  }

  .btn-confirm {
    background: #182589;
    color: #fff;
  }
}

@media (max-width: 768px) {
  .global-notify-dialog {
    width: calc(100% - 48px);
    max-width: 330px;
  }
}
</style>